import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { removeTags } from '@/utility';
import { buildReferencing, showInCitationPanelGenerator, useCitation } from '@/utils/citationPanelUtils';
import CitationEntryUnavailable from '@/components/citation-entry-unavailable.vue';
import { useRepositories } from '@/plugins/repositories';
export default defineComponent({
  name: 'CitationPanelGuideline',
  components: {
    CitationEntryUnavailable: CitationEntryUnavailable
  },
  props: {
    documentId: {
      type: String,
      required: false,
      default: undefined
    },
    sectionKeys: {
      type: Array,
      required: false,
      default: undefined
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props, context) {
    var router = useRouter();
    var repositories = useRepositories();
    var reference = computed(function () {
      return {
        documentId: props.documentId,
        sectionKeys: props.sectionKeys
      };
    });
    var _useCitation = useCitation(reference, {
        fetcher: function () {
          var _fetcher = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(documentId, sectionKeys) {
            var docSections;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return repositories.citations.getCitationGuideline(documentId, sectionKeys);
                case 2:
                  docSections = _context.sent;
                  return _context.abrupt("return", buildReferencing(docSections));
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function fetcher(_x, _x2) {
            return _fetcher.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        }),
        beforeFetch: function beforeFetch() {
          return context.emit('update:loading', true);
        },
        afterFetch: function afterFetch() {
          return context.emit('update:loading', false);
        }
      }),
      guidelines = _useCitation.list;
    var guidelineLink = function guidelineLink(guideline) {
      return "/document/".concat(guideline.docId);
    };
    var showInCitationPanel = showInCitationPanelGenerator(router);
    return {
      guidelines: guidelines,
      guidelineLink: guidelineLink,
      showInCitationPanel: showInCitationPanel,
      removeTags: removeTags
    };
  }
});